// Shared field validation helpers.

export function validEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

export function isValidHttpUrl(string) {
  try {
    const url = new URL(string)
    return url.protocol === 'http:' || url.protocol === 'https:'
  } catch (_) {
    return false
  }
}

export const YEAR_MIN = 1000

// A valid artwork year: an integer between YEAR_MIN and the current year.
// Mirrors the inline checks in WorkEditModal and ProfileSEOSettings.
export function isValidYear(value) {
  const y = parseInt(value)
  return !isNaN(y) && y >= YEAR_MIN && y <= new Date().getFullYear()
}
